import type { ReactNode } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/atoms/button';

interface DataTablePaginationFooterProps {
  count: number;
  singular: string;
  plural?: string;
  countLabel?: ReactNode;
  page: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
  showPagination?: boolean;
}

export function DataTablePaginationFooter({
  count,
  singular,
  plural,
  countLabel,
  page,
  totalPages,
  onPrevious,
  onNext,
  showPagination,
}: DataTablePaginationFooterProps) {
  const label = count === 1 ? singular : (plural ?? `${singular}s`);
  const shouldShowPagination = showPagination ?? (count > 0 && totalPages > 1);

  return (
    <div className="flex shrink-0 items-center justify-between border-t px-4 py-2">
      <span className="text-xs text-muted-foreground">{countLabel ?? `${count} ${label}`}</span>
      {shouldShowPagination ? (
        <div className="flex items-center gap-1">
          <Button
            variant="outline"
            size="icon"
            className="h-6 w-6"
            disabled={page === 1}
            onClick={onPrevious}
          >
            <ChevronLeft size={12} />
          </Button>
          <span className="px-1 text-xs text-muted-foreground">
            {page} / {totalPages}
          </span>
          <Button
            variant="outline"
            size="icon"
            className="h-6 w-6"
            disabled={page >= totalPages}
            onClick={onNext}
          >
            <ChevronRight size={12} />
          </Button>
        </div>
      ) : null}
    </div>
  );
}
